import { Sun, Moon, Monitor } from 'lucide-react'
import { useTheme } from '@/context/ThemeContext'

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme()

  const icon = theme === 'light'
    ? <Sun className="w-5 h-5" strokeWidth={2} />
    : theme === 'dark'
    ? <Moon className="w-5 h-5" strokeWidth={2} />
    : <Monitor className="w-5 h-5" strokeWidth={2} />

  const label =
    theme === 'light' ? 'Light mode (tap for dark)' :
    theme === 'dark'  ? 'Dark mode (tap for system)' :
                        'System mode (tap for light)'

  return (
    <button
      onClick={toggleTheme}
      className="text-muted-foreground hover:text-foreground transition-colors p-2.5"
      aria-label={label}
      title={label}
    >
      {icon}
    </button>
  )
}
